var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinearbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1161,
    height: 1117,
    viewBox: "0 0 1161 1117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 936.07,
    y: -907,
    width: 1977,
    height: 1903,
    rx: 147,
    transform: "rotate(31.3502 936.07 -907)",
    fill: "url(#paint0_linear_249_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_7",
    x1: 1924.57,
    y1: -907,
    x2: 1924.57,
    y2: 996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3655F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearbg);
export default __webpack_public_path__ + "static/media/linearbg.145fe1e45f629945660a7d61aedf75d8.svg";
export { ForwardRef as ReactComponent };